// extracted by mini-css-extract-plugin
export default {"apiResponseAlert":"ApiResponseAlert_apiResponseAlert__NuuLg"};